import { useEffect, useRef } from 'react';
import { defineMessage } from 'react-intl';
import { PreviewType } from 'js/file_viewer/core/types/preview_type';
const canShowSlideshow = (isSlideshowStormcrowEnabled, isFileFlippingEnabled, isNestedArchive, isSharedFile) => {
    return isSlideshowStormcrowEnabled && isFileFlippingEnabled && !isNestedArchive && !isSharedFile;
};
export const shouldShowSlideshowControls = (previewType, isSlideshowStormcrowEnabled, isFileFlippingEnabled, isNestedArchive = false, isSharedFile) => {
    const isImageOrVideo = previewType === PreviewType.Video || previewType === PreviewType.Image;
    return (canShowSlideshow(isSlideshowStormcrowEnabled, isFileFlippingEnabled, isNestedArchive, isSharedFile) &&
        (isImageOrVideo || previewType === PreviewType.Error));
};
export const shouldShowSlideshowButton = (previewType, isSlideshowStormcrowEnabled, isFileFlippingEnabled, isNestedArchive = false, isSharedFile) => {
    const isImageOrVideo = previewType === PreviewType.Video || previewType === PreviewType.Image;
    return (canShowSlideshow(isSlideshowStormcrowEnabled, isFileFlippingEnabled, isNestedArchive, isSharedFile) && isImageOrVideo);
};
export const flipPreviousMessage = defineMessage({ id: "gMA39w", defaultMessage: "Navigate to the previous slideshow file" });
export const flipNextMessage = defineMessage({ id: "/Bi0z4", defaultMessage: "Navigate to the next slideshow file" });
export const pauseMessage = defineMessage({ id: "NJcnxO", defaultMessage: "Pause" });
export const playMessage = defineMessage({ id: "iooQK2", defaultMessage: "Play" });
export const durationAriaLabelMessage = defineMessage({ id: "+pK+N8", defaultMessage: "Duration Dropdown menu" });
export const durationDropdownBtnMessage = defineMessage({ id: "Dady56", defaultMessage: "Duration" });
export const SLIDESHOW_DURATIONS_MS = [2000, 3000, 5000, 8000, 15000, 30000, 60000];
export function useSlideshowFlipping(callback, delay, rootPreviewKey) {
    const savedCallback = useRef(undefined);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        function fn() {
            if (savedCallback === null || savedCallback === void 0 ? void 0 : savedCallback.current) {
                savedCallback.current();
            }
        }
        if (delay && rootPreviewKey) {
            const interval = setInterval(fn, delay);
            return () => clearInterval(interval);
        }
        return () => { };
    }, [delay, rootPreviewKey]);
}
//# sourceMappingURL=slideshow.preenvesnextjs.map
